import React from 'react';
import { connect } from 'react-redux';

import * as CalendarState from '../../../state/reducer/calendar/calendar';
import DialogFactory from '../../factory/DialogFactory';
import Console from '../../../lib/debug';

export class ConfirmUnsubscribeDialogClass extends React.Component {
    handleClose = () => {
        const subscribedCalendar = this.props.subscribedCalendar;
        const isOpen = false;
        CalendarState.toggleDrawerCalendarDialog(isOpen, subscribedCalendar);
    };

    unsubscribeCalendar = () => {
        const teamId = this.props.team.group_id;
        const subscribedCalendar = this.props.subscribedCalendar;
        CalendarState.unsubscribeCalendar(subscribedCalendar, teamId);
    };

    getConfirmBody = () => {
        return (
            <div>
                {`Unsubscribing will remove all
                    '${this.props.subscribedCalendar.title}'
                    sessions from your calendar.`}
            </div>
        );
    };

    render() {
        Console.render('calendar.ConfirmUnsubscribeDialog');
        return (
            <DialogFactory
                enabled={this.props.openCalendar}
                handleClose={this.handleClose}
                handleSave={this.unsubscribeCalendar}
                header="Are You Sure?"
                text={this.getConfirmBody()}
                cancelButtonTitle="Cancel"
                saveButtonTitle="Unsubscribe"
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        openCalendar: !!state.calendar.uiTree.drawerDialogs.calendar,
        subscribedCalendar: state.calendar.uiTree.drawerDialogs.item,
        programType: state.calendar.infoTree.programType,
        team: state.calendar.infoTree.team,
        ...ownProps
    };
};

export default connect(mapStateToProps)(ConfirmUnsubscribeDialogClass);



// WEBPACK FOOTER //
// ./src/view/calendar/calendar-dialogs/ConfirmUnsubscribeDialog.jsx